import Swal from 'sweetalert2'
import { useContext, useEffect, useState } from 'react';

import DireccionContext from 'context/DireccionContext';
import {
    getAll,
    create,
    update,
    del,
    getVinculedDirectionsWithClient,
    vinculedDirection,
    desvinculedDirection
} from "services/DireccionService.js";

let totalPages;

export function useDireccion() {
    const [page, setPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5)

    const {
        setDireccion,
        allDirecciones,
        setAllDirecciones,
        direcciones,
        setDirecciones,
        vinculedDirecciones,
        setVinculedDirecciones,
        message,
        setMessage,
        loading,
        setLoading
    } = useContext(DireccionContext);

    
    const getAllDirecciones = async ({ mailClient, codCiudad, codDepartamento }) => {
        try {
            const response = await getAll({ mailClient, codCiudad, codDepartamento });
            setAllDirecciones(response)
            return response
        } catch (err) {
            const { data, status } = err.response;
            setMessage({ message: data.message, status });
        }
    }

    const getDirecciones = async ({ page = 1, limit = itemsPerPage, mailClient, codCiudad, codDepartamento }) => {
        setLoading(true);
        setPage(page);
        try {
            const allDirecciones = await getAllDirecciones({ mailClient, codCiudad, codDepartamento });
            setAllDirecciones(allDirecciones);
            totalPages = Math.ceil(allDirecciones.length / limit)
            const direcciones = await getAll({ page, limit: limit, mailClient, codCiudad, codDepartamento });
            setDirecciones(direcciones);
            setLoading(false);
        } catch (err) {
            const { data, status } = err.response;
            setMessage({ message: data.message, status });
            setLoading(false);
        }
    }

    const getVinculedDirections = async ({mail}) => {
        setLoading(true);
        try {
            const response = await getVinculedDirectionsWithClient({mail});
            setVinculedDirecciones(response);
            setLoading(false);
            return response
        } catch (err) {
            const { data, status } = err.response;
            const message = data.message;
            setMessage({ message, status });
            Swal.fire(
                'Ocurrió un Error!!!',
                message,
                'error'
            )
            setLoading(false);
        }
    }

    const likeDireccion = async({direccion, cliente}) => {
        const idDireccion = direccion._id;
        const idCliente = cliente._id;
        setLoading(true);
        try {
            const {message} = await vinculedDirection({idDireccion, idCliente});
            setMessage({ message, status: 200 });
            Swal.fire(
                'Éxito!!!',
                message,
                'success'
            )
            setLoading(false);
            return cliente.mail;
        } catch (err) {
            const { data, status } = err.response;
            const message = data.message;
            
            setMessage({ message, status });
            Swal.fire(
                'Ocurrió un Error!!!',
                message,
                'error'
            )
            setLoading(false);
        }
    }

    const unlikeDireccion = async ({direccion, cliente}) => {
        const idDireccion = direccion._id;
        const idCliente = cliente._id
        setLoading(true);
        try {
            const {message} = await desvinculedDirection({idDireccion, idCliente});
            setMessage({ message, status: 200 });
            Swal.fire(
                'Éxito!!!',
                message,
                'success'
            )
            setLoading(false);
            return cliente.mail;
        } catch (err) {
            const { data, status } = err.response;
            const message = data.message;
            
            setMessage({ message, status });
            Swal.fire(
                'Ocurrió un Error!!!',
                message,
                'error'
            )
            setLoading(false);
        }
    }

    const createDireccion = async ({ direccion }) => {
        try {
            const { message } = await create({ direccion })
            setMessage(state => ({ ...state, message }))
            Swal.fire(
                'Éxito!!!',
                message,
                'success'
            )
            getDirecciones({ page })
            return ''
        } catch (err) {
            const { data, status } = err.response
            setMessage({ message: data.message, status })
            return status
        }
    }

    const updateDireccion = async ({ direccion, id }) => {
        try {
            const { message } = await update({ direccion, id })
            setMessage({ message: '', status: 200 })
            Swal.fire(
                'Éxito!!!',
                message,
                'success'
            )
            getDirecciones({ page })
            return ''
        } catch (err) {
            const { data, status } = err.response
            setMessage({ message: data.message, status })
            return status
        }
    }

    const deleteDireccion = async ({ id }) => {
        Swal.fire({
            title: 'Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                (async () => {
                    try {
                        const { message } = await del({ id })
                        setMessage({ message: '', status: 200 })

                        Swal.fire(
                            'Éxito!!!',
                            message,
                            'success'
                        )
                        getDirecciones({ page })
                    } catch (err) {
                        const { data, status } = err.response
                        setMessage({ message: data.message, status })
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: data.message,
                        })
                    }
                })();
            }
        })
    }

    useEffect(() => {
        getDirecciones({});
        // eslint-disable-next-line
    }, [])

    return { 
        allDirecciones, 
        direcciones, 
        setDireccion, 
        page, 
        totalPages, 
        status: message.status, 
        loading, 
        deleteDireccion, 
        updateDireccion, 
        createDireccion, 
        getDirecciones, 
        setPage, 
        vinculedDirecciones, 
        getVinculedDirections, 
        likeDireccion, 
        unlikeDireccion,
        itemsPerPage, 
        setItemsPerPage,
    }
}